import { render } from "./ResellersPayouts.vue?vue&type=template&id=541fe987&scoped=true"
import script from "./ResellersPayouts.vue?vue&type=script&lang=js"
export * from "./ResellersPayouts.vue?vue&type=script&lang=js"

import "./ResellersPayouts.vue?vue&type=style&index=0&id=541fe987&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-541fe987"]])

export default __exports__